<template>
  <div class="meeting">
    <div slot="container">
      <div class="meeting-search">
        <el-input
          placeholder="请输入内容"
          v-model="params.keyword"
          class="input-with-select"
          @keyup.enter.native="search"
          clearable
          @clear="search"
        >
          <el-button
            slot="append"
            icon="el-icon-search"
            @click="search"
          ></el-button>
        </el-input>
        <el-select
          v-model="params.meetingSignInId"
          placeholder="请选择会议"
          filterable
          clearable
          @change="search"
          style="margin-right: 15px;"
        >
          <el-option
            v-for="item in meetingList"
            :key="item.id"
            :label="item.name"
            :value="item.id"
          ></el-option>
        </el-select>
        <el-button
          type="primary"
          size="mini"
          @click="exportOut"
          :disabled="tableData.length == 0"
          >导出</el-button
        >
      </div>
      <div class="meeting-table">
        <el-table
          ref="multipleTable"
          :data="tableData"
          style="width: 100%"
          :header-cell-style="{ background: '#E5F3FE', color: '#623AA2' }"
          class="table"
        >
          <el-table-column type="index" width="150" label="序号" align="center">
            <template slot-scope="scope">
              <span>{{
                scope.$index + (params.page - 1) * params.pageSize + 1
              }}</span>
            </template>
          </el-table-column>
          <el-table-column
            label="会议名称"
            prop="meetingName"
            align="center"
          ></el-table-column>
          <el-table-column label="单位" prop="unit" align="center">
          </el-table-column>
          <el-table-column label="职务" prop="position" align="center">
          </el-table-column>
          <el-table-column
            label="姓名"
            prop="name"
            align="center"
          ></el-table-column>
          <el-table-column
            label="手机"
            prop="phone"
            align="center"
          ></el-table-column>
          <el-table-column
            label="签到时间"
            prop="createTime"
            align="center"
          ></el-table-column>
        </el-table>
      </div>
      <el-pagination
        @current-change="handleCurrentChange"
        :current-page.sync="params.page"
        :page-size="params.pageSize"
        layout="total, prev, pager, next"
        :total="total"
        style="text-align:left;margin:20px 0"
      ></el-pagination>
    </div>
  </div>
</template>
<script>
import download from "@/utils/download";
export default {
  data() {
    return {
      params: {
        keyword: "",
        page: 1,
        pageSize: 10,
      },
      meetingList: [],
      tableData: [],
      total: 1,
    };
  },
  created() {
    this.getMeetingList();
    this.getData();
  },
  methods: {
    search() {
      this.params.page = 1;
      this.getData();
    },
    //翻页
    handleCurrentChange(val) {
      this.params.page = val;
      this.getData();
      //   this.getData('Knowledge?type=1&page=' + val);
    },
    //导出
    async exportOut() {
      let url = `${urlConfig.devUrl}apij2/admin-api/trade/electronic-sign-in/export-excel`;
      try {
        const response = await this.axios.post(url, this.params, {
          responseType: "blob",
        });
        download.excel(response.data, "会议签到名单.xls");
      } catch (error) {
        console.error("Download failed:", error);
      }
    },
    getMeetingList() {
      this.http
        .post(`${urlConfig.devUrl}apij2/admin-api/trade/meeting-sign-in/page`, {
          is_page: 1,
        })
        .then((res) => {
          this.meetingList = res.data.data;
        });
    },
    getData() {
      this.http
        .post(
          `${urlConfig.devUrl}apij2/admin-api/trade/electronic-sign-in/page`,
          this.params
        )
        .then((res) => {
          console.log(res);
          this.tableData = res.data.data;
          this.total = res.data.total;
        });
    },
  },
};
</script>
<style lang="scss" scoped>
@include component(meeting) {
  width: 100%;
  height: 100%;
  .meeting-search {
    width: 100%;
    text-align: left;
    display: flex;
    justify-content: flex-start;
    .el-input {
      width: 300px;
      margin-right: 15px;
    }
  }
  .meeting-table {
    width: 100%;
    margin-top: 10px;
    border: 1px solid #eef1f6;
  }
  .avatar-uploader {
    text-align: center;
    width: 243px;
    img {
      max-width: 100%;
    }
  }
  .del_img {
    position: absolute;
    top: -7px;
    left: 224px;
    color: #00a1ff;
  }
  /deep/ .el-upload {
    border: 1px dashed #d9d9d9 !important;
    border-radius: 6px;
    cursor: pointer;
    position: relative;
    overflow: hidden;
  }

  /deep/ .el-upload:hover {
    border-color: #409eff !important;
  }

  .avatar-uploader-icon {
    font-size: 28px;
    color: #8c939d;
    width: 243px;
    height: 154px;
    line-height: 154px;
    text-align: center;
  }
}
</style>
